import { render, staticRenderFns } from "./ImageSwiper.vue?vue&type=template&id=22ede491&scoped=true&"
import script from "./ImageSwiper.vue?vue&type=script&lang=js&"
export * from "./ImageSwiper.vue?vue&type=script&lang=js&"
import style0 from "./ImageSwiper.vue?vue&type=style&index=0&id=22ede491&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ede491",
  null
  
)

export default component.exports